import { render } from "./PlanStep5.vue?vue&type=template&id=48ab781a&scoped=true"
import script from "./PlanStep5.vue?vue&type=script&lang=js"
export * from "./PlanStep5.vue?vue&type=script&lang=js"

import "./PlanStep5.vue?vue&type=style&index=0&id=48ab781a&lang=stylus"
import "./PlanStep5.vue?vue&type=style&index=1&id=48ab781a&scoped=true&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ab781a"]])

export default __exports__